// Angular
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-wrapper',
    templateUrl: './page-wrapper.component.html',
    styleUrls: ['./page-wrapper.component.scss'],
    standalone: false
})
export class PageWrapperComponent {
    @Input() addBtnText: string = '';
    @Input() createLink: string = '';
    @Input() loading: boolean = false;
    @Input() title: string = '';
}
